import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';
import { formatApiError } from '@/lib/api';
import Logo from '@/components/Logo';

// AuthCallback handles the redirect back from Emergent Google Auth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
	const { exchangeGoogleSession } = useAuth();
	const navigate = useNavigate();
	const hasProcessed = useRef(false);

	useEffect(() => {
		// Idempotent guard against React StrictMode double-invocation.
		if (hasProcessed.current) return;
		hasProcessed.current = true;

		const hash = window.location.hash || '';
		const match = hash.match(/session_id=([^&]+)/);
		const sessionId = match ? decodeURIComponent(match[1]) : null;
		if (!sessionId) {
			navigate('/login', { replace: true });
			return;
		}
		(async () => {
			try {
				await exchangeGoogleSession(sessionId);
				// Clean fragment so a refresh doesn't re-trigger.
				window.history.replaceState({}, '', '/dashboard');
				navigate('/dashboard', { replace: true });
			} catch (err) {
				toast.error(formatApiError(err, 'Google sign-in failed'));
				navigate('/login', { replace: true });
			}
		})();
	}, [exchangeGoogleSession, navigate]);

	return (
		<div className="min-h-screen grid place-items-center mesh-bg">
			<div className="flex flex-col items-center gap-4 text-slate-600">
				<Logo />
				<div className="w-3 h-3 rounded-full bg-emerald-500 animate-pulse-soft" />
				Setting up your family space…
			</div>
		</div>
	);
}
